import React from "react";
import type { ViewComponent } from "@frui.ts/views";
import { registerView, View } from "@frui.ts/views";
import { Observer, observer } from "mobx-react-lite";
import AccessRightsViewModel from "viewModels/users/accessRights/accessRightsViewModel";

const AccessRightsView: ViewComponent<AccessRightsViewModel> = observer(({ vm }) => {
  return <Observer>{() => <View vm={vm.activeChild} />}</Observer>;
});

registerView(AccessRightsView, AccessRightsViewModel);
